var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',_vm._b({class:{
    'table_cell--sticky-first': _vm.first,
    'table_cell--sticky-last': _vm.last,
    'table_cell--invalid': _vm.isInvalid,
  }},'td',_vm.$attrs,false),[_c('div',{directives:[{name:"line-clamp",rawName:"v-line-clamp",value:(3),expression:"3"}],staticClass:"sticky_table_cell"},[(!!_vm.invalidMessage)?_c('span',{staticClass:"table_cell--invalid_message"},[_vm._v(" "+_vm._s(_vm.invalidMessage))]):_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }